import { render, staticRenderFns } from "./EditSkillCategoryPage.vue?vue&type=template&id=a4f78838&"
import script from "./EditSkillCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditSkillCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports